import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
	position: relative;
`;

export const Container = styled.div`
	${({ loading }) => {
		loading &&
			css`
				width: 40rem;
				height: 10.2rem;
				& > div {
					display: flex;
					justify-content: center;
					align-items: center;
				}
			`;
	}}
`;

export const LoaderWrapper = styled.div`
	width: 20rem;
	height: 7.8rem;
	display: flex;
	justify-content: center;
	align-items: center;
`;
